import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SidebarOpenHover = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 3V21'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.696 9.696 17 12l-2.304 2.304'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.6 2.25c1.107 0 1.984 0 2.688.057.713.058 1.317.18 1.868.46a4.75 4.75 0 0 1 2.076 2.077c.281.55.403 1.155.461 1.868.058.705.057 1.58.057 2.688v5.2c0 1.107 0 1.984-.057 2.688-.058.713-.18 1.317-.46 1.868a4.75 4.75 0 0 1-2.077 2.076c-.55.281-1.155.403-1.868.461-.704.058-1.58.057-2.688.057H9.4c-1.107 0-1.983 0-2.688-.057-.713-.058-1.317-.18-1.868-.46a4.75 4.75 0 0 1-2.076-2.077c-.281-.55-.403-1.155-.461-1.868-.058-.704-.057-1.58-.057-2.688V9.4c0-1.107 0-1.983.057-2.688.058-.713.18-1.317.46-1.868a4.75 4.75 0 0 1 2.077-2.076c.55-.281 1.155-.403 1.868-.461.705-.058 1.58-.057 2.688-.057zm-3.85 18h3.85c1.132 0 1.937 0 2.566-.052.62-.05 1.005-.147 1.31-.303a3.25 3.25 0 0 0 1.42-1.42c.155-.304.252-.688.302-1.309.052-.63.052-1.434.052-2.566V9.4c0-1.132 0-1.937-.052-2.566-.05-.62-.147-1.005-.303-1.31a3.25 3.25 0 0 0-1.42-1.42c-.304-.155-.688-.252-1.309-.302-.63-.052-1.434-.052-2.566-.052h-3.85z'
          fill='currentColor'
        />
        <path
          d='M15.23 9.22a.75.75 0 0 0-1.06 1.06l1.774 1.774-1.774 1.774a.75.75 0 1 0 1.06 1.06l2.304-2.304a.75.75 0 0 0 0-1.06z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
